/* GENKIDAMA CART MAX (04.08.) - "Nmax;;" gilt NUR im Warenkorb.
 *
 * Regel (Boss): Steht am Produkt ein Tag wie "2max;;" (oder der Baustein
 * im Barcode der Variante), darf ein Kunde maximal 2 Stueck kaufen. Die Produktseite bleibt komplett
 * unangetastet - der Bubble ist ein reiner Zaehler.
 *
 * Arbeitsweise:
 *  - Der Warenkorb (/cart.js) kennt keine Barcodes. Deshalb wird pro
 *    Artikel einmal /products/<handle>.js geladen und die Grenze aus dem
 *    Barcode der Variante gelesen. Ergebnis wird gemerkt.
 *  - Liegt eine Zeile UEBER der Grenze: roter Hinweis an der Zeile und
 *    an der Kasse, Checkout-Knopf wird ausgegraut (disabled).
 *  - Passt die Menge wieder: SOFORT wieder frei - Zustand kommt live aus
 *    den Mengenfeldern, wie bei der Preis-Anzeige.
 *  - FAIL-OPEN: Bei jedem Fehler (Netz, Struktur, Theme-Update) passiert
 *    NICHTS - es wird nie faelschlich blockiert.
   *  - Checkout-Auswahl: Nicht markierte Artikel bleiben im Warenkorb. Dafuer
   *    werden sie vor dem Checkout kurz aus dem Warenkorb genommen und beim
   *    naechsten Warenkorb-Aufruf wiederhergestellt.
   */
(function () {
  'use strict';
  if (window.__genkidamaCartMaxLoaded) return;
  window.__genkidamaCartMaxLoaded = true;

  var maxByVariant = {};   // variant_id -> Grenze (0 = keine)
  var groupByVariant = {}; // variant_id -> Gruppen-Schluessel (V:2-7, REL:02.2027, ...)
  var gruppenNamen = {};   // Gruppen-Schluessel -> deutscher Name fuer Warntexte
  var gruppenNie = {};     // Gruppen-Schluessel -> true = darf NIE gemischt werden (pf-Vorbesteller)
  var lastValidQty = {};   // variant_id -> letzte REGELKONFORME Menge
  var productCache = {};   // handle -> Promise auf Produkt-JSON
  var lastCart = null;
  var refreshPending = false;
  var GRUPPEN_MINDESTWERT_CENT = 15000; // 150 EUR pro Gruppe, sobald gemischt wird
  var NORMAL_CHECKOUT_VERSAND_CENT = 499; // Shopify-Standardversand unter 150 EUR Warenwert
  var EXTRA_VERSAND_VARIANT_ID = 53477500813578;
  var EXTRA_VERSAND_HANDLE = 'extra-versand';
  var CHECKOUT_SELECTION_KEY = 'genkidama_checkout_selection_v1';
  var CHECKOUT_HOLD_KEY = 'genkidama_checkout_hold_v1';
  var CHECKOUT_HOLD_TTL_MS = 36 * 60 * 60 * 1000;
  var CHECKOUT_PARKED_LIMIT = 30;
  var checkoutSelectionBusy = false;
  var checkoutRestoreBusy = false;

  function parseMax(barcode) {
    var m = /(^|\s)(\d+)\s*max;;/i.exec(String(barcode || ''));
    if (!m) return 0;
    var n = parseInt(m[2], 10);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function parseMaxFromTags(tags) {
    // Boss (05.08.): Der Baustein steht in den TAGS, z.B. "2max;;".
    var list = Array.isArray(tags) ? tags : String(tags || '').split(',');
    var best = 0;
    for (var i = 0; i < list.length; i++) {
      var m = /^(\d+)\s*max\s*(;;)?$/i.exec(String(list[i] || '').trim());
      if (m) {
        var n = parseInt(m[1], 10);
        if (isFinite(n) && n > 0 && (best === 0 || n < best)) best = n;
      }
    }
    return best;
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function refreshLimits() {
    if (refreshPending) return;
    refreshPending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        lastCart = cart;
        if (migrateVisibleExtraVersandPackageIds(cart)) return null;
        var jobs = [];
        cart.items.forEach(function (item) {
          if (Object.prototype.hasOwnProperty.call(maxByVariant, item.variant_id)) return;
          jobs.push(fetchProduct(item.handle).then(function (product) {
            var max = 0;
            if (product && product.variants) {
              for (var i = 0; i < product.variants.length; i++) {
                if (product.variants[i].id === item.variant_id) {
                  max = parseMax(product.variants[i].barcode);
                  break;
                }
              }
            }
            if (!max && product) {
              max = parseMaxFromTags(product.tags);
            }
            maxByVariant[item.variant_id] = max;
            // FINALES REGELWERK (05.08., Boss):
            //  - Jede Versandart der Lagerware ist eine EIGENE Gruppe
            //    (1-3;;, 2-7;;, 4-15;;, 3month;; - jede wird ihr eigenes Paket).
            //  - Jeder Vorbesteller-Monat (code;;MM.JJJJ) ist eine eigene Gruppe.
            //  - Jeder GAME-Vorbesteller-Artikel ist eine eigene Single-Gruppe,
            //    auch bei gleichem Releasedatum.
            //  - pf;; IST das Games-Kennzeichen (Boss 05.08.). pf;;-LAGERware
            //    zaehlt bei ihrer Versandart mit (keine eigene Pflicht).
            //  - TCG bleibt immer eine eigene Paketgruppe und wird nicht mit
            //    Figuren/Lagerware zusammengefasst.
            var barcode = '';
            var selectedVariant = null;
            if (product && product.variants) {
              for (var gi = 0; gi < product.variants.length; gi++) {
                if (product.variants[gi].id === item.variant_id) {
                  selectedVariant = product.variants[gi];
                  barcode = String(selectedVariant.barcode || '');
                  break;
                }
              }
            }
            var tagsArr = (product && product.tags) || [];
            if (!Array.isArray(tagsArr)) tagsArr = String(tagsArr || '').split(',');
            var typBlob = (String((product && product.type) || '') + ' ' + tagsArr.join(' ')).toLowerCase();
            var istPf = tagsArr.some(function (t) { return /^pf;;?$/i.test(String(t || '').trim()); });
            var istGame = /(^|[^a-z])games?([^a-z]|$)/.test(typBlob);
            var istTcg = /spielkarten|sammelkarten|sammelkarte|trading card|tcg/.test(typBlob);
            var relM = /code;;\s*(\d{2}\.\d{4})/i.exec(barcode);
            var verM = /(^|\s)(\d+\s*month|\d+\s*-\s*\d+)\s*;;/i.exec(barcode);
            var versand = verM ? verM[2].replace(/\s+/g, '').toLowerCase() : '';
            var hasWarehouseShipping = versand && versand.indexOf('month') < 0;
            var variantIsAvailable = !selectedVariant || selectedVariant.available !== false;
            var activeWarehouseStock = hasWarehouseShipping && variantIsAvailable;
            var schluessel, name, nie = false;
            if (item.handle === EXTRA_VERSAND_HANDLE || Number(item.variant_id) === EXTRA_VERSAND_VARIANT_ID) {
              schluessel = 'EXTRA:' + item.key;
              name = 'Extra Versand';
            } else if (relM && !activeWarehouseStock) {
              // EINE Regel fuer pf;;/Games (Boss 05.08., "FREI"): gleicher
              // Artikel darf sich stapeln und ab 150 EUR mischen - nur ZWEI
              // VERSCHIEDENE Game-Vorbesteller-Artikel sind verboten.
              if (istPf || istGame) {
                schluessel = 'GAME:' + item.variant_id;
                name = 'Game-Vorbesteller (' + relM[1] + ')';
              } else if (istTcg) {
                schluessel = 'TCG:' + item.variant_id;
                name = 'Spielkarten & TCG (' + relM[1] + ')';
              } else {
                schluessel = 'REL:' + relM[1];
                name = 'Vorbesteller ' + relM[1];
              }
            } else if (versand.indexOf('month') >= 0) {
              if (istTcg) {
                schluessel = 'TCG:' + item.variant_id;
                name = 'Spielkarten & TCG';
              } else {
                schluessel = 'V:3month';
                name = 'Seeweg (45\u201390 Werktage)';
              }
            } else {
              if (istTcg) {
                schluessel = 'TCG:' + item.variant_id;
                if (versand === '1-3') name = 'Spielkarten & TCG (1\u20133 Tage)';
                else if (versand === '2-7') name = 'Spielkarten & TCG (2\u20137 Tage)';
                else if (versand === '4-15') name = 'Spielkarten & TCG (4\u201315 Tage)';
                else name = 'Spielkarten & TCG';
              } else {
                schluessel = 'V:schnell';
                if (versand === '1-3') name = 'Expresslager (1\u20133 Tage)';
                else if (versand === '2-7') name = 'Lager (2\u20137 Tage)';
                else if (versand === '4-15') name = 'Fernlager (4\u201315 Tage)';
                else name = 'Lagerware (1\u201315 Tage)';
              }
            }
            groupByVariant[item.variant_id] = schluessel;
            if (schluessel === 'V:schnell' && gruppenNamen[schluessel] && gruppenNamen[schluessel] !== name) {
              gruppenNamen[schluessel] = 'Lagerware (1\u201315 Tage)';
            } else {
              gruppenNamen[schluessel] = name;
            }
            gruppenNie[schluessel] = nie;
          }));
        });
        return Promise.all(jobs);
      })
      .then(function () { refreshPending = false; evaluate(); })
      .catch(function () { refreshPending = false; });
  }

  function cartQuantityInputs() {
    var form = document.querySelector('form[action*="/cart"], cart-items, #cart');
    var scope = form || document;
    return Array.prototype.slice.call(scope.querySelectorAll('input[name="updates[]"]'));
  }

  function variantIdForInput(input, idx) {
    var direct = input.getAttribute('data-quantity-variant-id') || input.getAttribute('data-variant-id');
    if (direct) return String(direct);
    var item = cartItemForInput(input, idx);
    if (item) {
      return String(item.variant_id);
    }
    return '';
  }

  function cartLineIndexForInput(input, fallbackIdx) {
    var row = input && (input.closest('.cart-item') || input.closest('tr'));
    var id = row ? String(row.id || '') : '';
    var m = /(?:CartItem|CartDrawer-Item)-(\d+)/i.exec(id);
    if (m) return Math.max(0, parseInt(m[1], 10) - 1);
    return fallbackIdx;
  }

  function cartItemForInput(input, fallbackIdx) {
    if (!lastCart || !lastCart.items) return null;
    var idx = cartLineIndexForInput(input, fallbackIdx);
    return lastCart.items[idx] || null;
  }

  function inputForCartIndex(inputs, idx) {
    for (var i = 0; i < inputs.length; i++) {
      if (cartLineIndexForInput(inputs[i], i) === idx) return inputs[i];
    }
    return null;
  }

  function isExtraVersandItem(item) {
    return !!item && (item.handle === EXTRA_VERSAND_HANDLE || Number(item.variant_id) === EXTRA_VERSAND_VARIANT_ID);
  }

  function readStoredJson(key, fallback) {
    try {
      var raw = window.localStorage ? window.localStorage.getItem(key) : null;
      if (!raw) return fallback;
      return JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function writeStoredJson(key, value) {
    try {
      if (!window.localStorage) return false;
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      return false;
    }
  }

  function removeStoredJson(key) {
    try {
      if (window.localStorage) window.localStorage.removeItem(key);
    } catch (e) { /* fail-open */ }
  }

  function propsSignature(props) {
    props = props || {};
    return Object.keys(props).sort().map(function (key) {
      return key + '=' + String(props[key]);
    }).join('|');
  }

  function cloneCartProperties(item) {
    var out = {};
    var props = (item && item.properties) || {};
    Object.keys(props).forEach(function (key) {
      if (props[key] !== null && props[key] !== undefined && props[key] !== '') out[key] = props[key];
    });
    return out;
  }

  function selectionKeyForItem(item) {
    if (!item) return '';
    return String(item.key || ((item.variant_id || '') + '|' + propsSignature(item.properties || {}) + '|' + (item.product_id || '')));
  }

  function readCheckoutSelection() {
    var data = readStoredJson(CHECKOUT_SELECTION_KEY, {});
    return data && typeof data === 'object' ? data : {};
  }

  function saveCheckoutSelection(data) {
    writeStoredJson(CHECKOUT_SELECTION_KEY, data || {});
  }

  function isRealCartItemSelected(item) {
    if (!item || isExtraVersandItem(item)) return false;
    var key = selectionKeyForItem(item);
    var selection = readCheckoutSelection();
    return selection[key] !== false;
  }

  function checkoutParkedLineCount(cart, selection) {
    try {
      if (!cart || !cart.items) return 0;
      selection = selection || readCheckoutSelection();
      var count = 0;
      (cart.items || []).forEach(function (item) {
        if (!item || isExtraVersandItem(item)) return;
        if (selection[selectionKeyForItem(item)] === false) count += Math.max(1, Number(item.quantity) || 1);
      });
      return count;
    } catch (e) {
      return 0;
    }
  }

  function normalizeCheckoutParkedLimit(cart, selection) {
    try {
      if (!cart || !cart.items) return selection || {};
      selection = selection || readCheckoutSelection();
      var count = 0;
      var changed = false;
      (cart.items || []).forEach(function (item) {
        if (!item || isExtraVersandItem(item)) return;
        var key = selectionKeyForItem(item);
        if (selection[key] !== false) return;
        var qty = Math.max(1, Number(item.quantity) || 1);
        if (count + qty > CHECKOUT_PARKED_LIMIT) {
          delete selection[key];
          changed = true;
          return;
        }
        count += qty;
      });
      if (changed) saveCheckoutSelection(selection);
      return selection;
    } catch (e) {
      return selection || {};
    }
  }

  function checkoutParkedLimitText(count) {
    return 'Maximal ' + CHECKOUT_PARKED_LIMIT + ' geparkte Artikel moeglich. Aktuell waeren es ' + count + '. Bitte erst einen geparkten Artikel wieder auswaehlen oder entfernen.';
  }

  function quantityForCartIndex(item, idx, inputs) {
    var input = inputForCartIndex(inputs || cartQuantityInputs(), idx);
    var qty = input ? (parseInt(String(input.value || '0'), 10) || 0) : (Number(item && item.quantity) || 0);
    return Math.max(0, qty);
  }

  function selectedGroupMap(inputs) {
    var groups = {};
    if (!lastCart || !lastCart.items) return groups;
    (lastCart.items || []).forEach(function (item, idx) {
      if (isExtraVersandItem(item) || !isRealCartItemSelected(item)) return;
      var qty = quantityForCartIndex(item, idx, inputs);
      var group = groupForCartItem(item);
      if (qty > 0 && group && String(group).indexOf('EXTRA:') !== 0) groups[group] = true;
    });
    return groups;
  }

  function extraSelectedByGroups(item, selectedGroups) {
    if (!isExtraVersandItem(item)) return false;
    var gid = extraVersandGroupIdFromItem(item);
    return !!gid && !!(selectedGroups || {})[gid];
  }

  function itemSelectedForCheckout(item, selectedGroups) {
    if (isExtraVersandItem(item)) return extraSelectedByGroups(item, selectedGroups);
    return isRealCartItemSelected(item);
  }

  function selectedCheckoutTotalCents(inputs) {
    try {
      inputs = inputs || cartQuantityInputs();
      if (!lastCart || !lastCart.items || !inputs || lastCart.items.length !== inputs.length) return null;
      var selectedGroups = selectedGroupMap(inputs);
      var total = 0;
      var realGoodsTotal = 0;
      (lastCart.items || []).forEach(function (item, idx) {
        if (!item) return;
        var qty = quantityForCartIndex(item, idx, inputs);
        if (qty <= 0) return;
        if (!itemSelectedForCheckout(item, selectedGroups)) return;
        var lineTotal = (Number(item.final_price || item.price || 0) || 0) * qty;
        if (!isExtraVersandItem(item)) realGoodsTotal += lineTotal;
        total += lineTotal;
      });
      if (realGoodsTotal > 0 && realGoodsTotal < GRUPPEN_MINDESTWERT_CENT) {
        total += NORMAL_CHECKOUT_VERSAND_CENT;
      }
      return Math.max(0, Math.round(total));
    } catch (e) {
      return null;
    }
  }

  function formatCheckoutTotal(cents) {
    var value = (Math.max(0, Number(cents) || 0) / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return '\u20AC' + value + ' EUR';
  }

  function cartTotalDisplayTargets() {
    var selectors = [
      '#main-cart-footer .totals__total-value',
      '#main-cart-footer [data-cart-total]',
      '.cart__footer .totals__total-value',
      '.totals__total-value'
    ];
    var seen = [];
    return Array.prototype.slice.call(document.querySelectorAll(selectors.join(','))).filter(function (el) {
      if (!el || seen.indexOf(el) >= 0) return false;
      seen.push(el);
      return true;
    });
  }

  function restoreSelectedCheckoutTotalDisplay() {
    cartTotalDisplayTargets().forEach(function (el) {
      if (el && el.dataset && el.dataset.genkidamaOriginalTotalText) {
        el.textContent = el.dataset.genkidamaOriginalTotalText;
        delete el.dataset.genkidamaActiveCheckoutTotal;
      }
    });
  }

  function updateSelectedCheckoutTotalDisplay(inputs) {
    var cents = selectedCheckoutTotalCents(inputs);
    if (cents === null) {
      restoreSelectedCheckoutTotalDisplay();
      return;
    }
    var text = formatCheckoutTotal(cents);
    cartTotalDisplayTargets().forEach(function (el) {
      if (!el || !el.dataset) return;
      if (!el.dataset.genkidamaOriginalTotalText) {
        el.dataset.genkidamaOriginalTotalText = el.textContent || '';
      }
      el.textContent = text;
      el.dataset.genkidamaActiveCheckoutTotal = '1';
    });
  }

  function updateCheckoutSelectionNotice(selectedCount, heldCount) {
    try {
      var btns = checkoutButtons();
      if (!btns.length) return;
      var note = document.getElementById('genkidama-checkout-selection-note');
      if (!note) {
        note = document.createElement('div');
        note.id = 'genkidama-checkout-selection-note';
        note.className = 'genkidama-checkout-selection-note';
        var parent = btns[0].parentNode;
        if (parent) parent.insertBefore(note, btns[0]);
      }
      if (selectedCount <= 0) {
        note.textContent = 'Bitte mindestens einen Artikel fuer diesen Checkout auswaehlen.';
      } else if (!heldCount) {
        note.textContent = 'Hinweis: Artikel ohne Haken bleiben fuer spaeter im Warenkorb. Maximal ' + CHECKOUT_PARKED_LIMIT + ' geparkte Artikel moeglich.';
      } else {
        note.textContent = selectedCount + ' Artikel gehen in diesen Checkout. ' + heldCount + ' Artikel bleiben fuer spaeter im Warenkorb. Maximal ' + CHECKOUT_PARKED_LIMIT + ' geparkte Artikel moeglich.';
      }
    } catch (e) { /* fail-open */ }
  }

  function renderHeldCheckoutRestoreNotice() {
    try {
      var old = document.getElementById('genkidama-held-checkout-restore');
      var hold = readStoredJson(CHECKOUT_HOLD_KEY, null);
      if (!hold || !hold.items || !hold.items.length || (((new Date()).getTime() - Number(hold.createdAt || 0)) > CHECKOUT_HOLD_TTL_MS)) {
        if (old) old.remove();
        if (hold) removeStoredJson(CHECKOUT_HOLD_KEY);
        return;
      }
      var footer = document.getElementById('main-cart-footer') || document.querySelector('cart-items') || document.getElementById('main-cart-items');
      if (!footer) return;
      var count = hold.items.reduce(function (sum, item) { return sum + (Number(item && item.quantity) || 0); }, 0);
      if (!old) {
        old = document.createElement('div');
        old.id = 'genkidama-held-checkout-restore';
        old.className = 'genkidama-held-checkout-restore';
        old.innerHTML = '<div class="genkidama-held-checkout-copy"><strong>Fuer spaeter gespeichert</strong><span></span></div><button type="button" class="button genkidama-held-checkout-btn">Wieder in den Warenkorb legen</button>';
        footer.parentNode.insertBefore(old, footer);
      }
      var text = old.querySelector('.genkidama-held-checkout-copy span');
      if (text) text.textContent = count + ' Artikel wurden beim letzten Checkout zurueckgelegt und bleiben hier fuer spaeter gespeichert.';
      var btn = old.querySelector('.genkidama-held-checkout-btn');
      if (btn && !btn.dataset.bound) {
        btn.dataset.bound = '1';
        btn.addEventListener('click', function () {
          if (lastCart) restoreHeldCheckoutItems(lastCart, true);
        });
      }
    } catch (e) { /* fail-open */ }
  }

  function decorateCheckoutSelectionRows() {
    try {
      ensurePackageFrameStyles();
      if (!lastCart || !lastCart.items) return;
      var selection = normalizeCheckoutParkedLimit(lastCart, readCheckoutSelection());
      var seen = {};
      var selectedGroups = selectedGroupMap();
      var rows = Array.prototype.slice.call(document.querySelectorAll('#main-cart-items tr.cart-item'));
      rows.forEach(function (row, fallbackIdx) {
        var input = row.querySelector('input[name="updates[]"]');
        var idx = cartLineIndexForInput(input || row, fallbackIdx);
        var item = lastCart.items[idx];
        if (!item) return;
        var details = row.querySelector('.cart-item__details') || row.querySelector('td') || row;
        var oldWrap = details.querySelector('.genkidama-checkout-select-wrap');
        if (isExtraVersandItem(item)) {
          if (oldWrap) oldWrap.remove();
          row.classList.toggle('genkidama-checkout-held', !extraSelectedByGroups(item, selectedGroups));
          return;
        }
        var key = selectionKeyForItem(item);
        seen[key] = true;
        var selected = selection[key] !== false;
        if (!oldWrap) {
          oldWrap = document.createElement('label');
          oldWrap.className = 'genkidama-checkout-select-wrap';
          var cb = document.createElement('input');
          cb.type = 'checkbox';
          cb.className = 'genkidama-checkout-select';
          cb.setAttribute('data-genkidama-checkout-select', '1');
          var text = document.createElement('span');
          text.className = 'genkidama-checkout-select-text';
          oldWrap.appendChild(cb);
          oldWrap.appendChild(text);
          var before = details.querySelector('.genkidama-cart-title-price') || details.firstChild;
          if (before) details.insertBefore(oldWrap, before);
          else details.appendChild(oldWrap);
        }
        var box = oldWrap.querySelector('input[type="checkbox"]');
        var labelText = oldWrap.querySelector('.genkidama-checkout-select-text');
        if (box) {
          box.checked = selected;
          box.dataset.cartLineKey = key;
        }
        if (labelText) labelText.textContent = selected ? 'In diesen Checkout' : 'Bleibt im Warenkorb';
        row.classList.toggle('genkidama-checkout-held', !selected);
      });
      Object.keys(selection).forEach(function (key) {
        if (!seen[key]) delete selection[key];
      });
      saveCheckoutSelection(selection);
    } catch (e) { /* fail-open */ }
  }

  function restoreHeldCheckoutItems(cart, force) {
    try {
      if (checkoutRestoreBusy) return true;
      if (!/(^|\/)cart\/?$/.test(window.location.pathname || '')) return false;
      if (!force) return false;
      var hold = readStoredJson(CHECKOUT_HOLD_KEY, null);
      if (!hold || !hold.items || !hold.items.length) return false;
      if (((new Date()).getTime() - Number(hold.createdAt || 0)) > CHECKOUT_HOLD_TTL_MS) {
        removeStoredJson(CHECKOUT_HOLD_KEY);
        return false;
      }
      var existing = {};
      ((cart && cart.items) || []).forEach(function (item) {
        if (!item || isExtraVersandItem(item)) return;
        var sig = String(item.variant_id || '') + '|' + propsSignature(item.properties || {});
        existing[sig] = (existing[sig] || 0) + (Number(item.quantity || 0) || 0);
      });
      var toAdd = [];
      hold.items.forEach(function (item) {
        if (!item || !item.id || !item.quantity) return;
        var props = item.properties || {};
        var sig = String(item.id) + '|' + propsSignature(props);
        var already = existing[sig] || 0;
        if (already >= item.quantity) return;
        toAdd.push({
          id: item.id,
          quantity: item.quantity - already,
          properties: props
        });
      });
      if (!toAdd.length) {
        removeStoredJson(CHECKOUT_HOLD_KEY);
        return false;
      }
      checkoutRestoreBusy = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: toAdd })
      }).then(function (r) {
        if (!r.ok) throw new Error('restore failed');
        removeStoredJson(CHECKOUT_HOLD_KEY);
        window.location.reload();
      }).catch(function () {
        checkoutRestoreBusy = false;
      });
      return true;
    } catch (e) {
      checkoutRestoreBusy = false;
      return false;
    }
  }

  function groupForCartItem(item) {
    if (!item) return undefined;
    if (item.handle === EXTRA_VERSAND_HANDLE || Number(item.variant_id) === EXTRA_VERSAND_VARIANT_ID) {
      return 'EXTRA:' + item.key;
    }
    var splitId = splitPackageIdFromItem(item);
    if (splitId) {
      var baseGroup = groupByVariant[item.variant_id];
      var baseName = gruppenNamen[baseGroup] || 'Versandgruppe';
      gruppenNamen[splitId] = 'Geteiltes Paket - ' + baseName;
      gruppenNie[splitId] = false;
      return splitId;
    }
    return groupByVariant[item.variant_id];
  }

  function splitPackageIdFromItem(item) {
    var props = (item && item.properties) || {};
    return String(
      props._genkidama_split_package ||
      props['_genkidama_split_package'] ||
      props['Split-Paket-ID'] ||
      ''
    ).trim();
  }

  function splitOriginFromItem(item) {
    var props = (item && item.properties) || {};
    return String(
      props._genkidama_split_origin ||
      props['_genkidama_split_origin'] ||
      props['Split-Ursprung'] ||
      ''
    ).trim();
  }

  function publicCartProperties(item) {
    var out = {};
    var props = (item && item.properties) || {};
    Object.keys(props).forEach(function (key) {
      var value = props[key];
      if (value === null || value === undefined || value === '') return;
      if (String(key || '').charAt(0) === '_') return;
      out[key] = value;
    });
    return out;
  }

  function publicCartPropertiesWithoutSplit(item) {
    var out = {};
    var props = (item && item.properties) || {};
    Object.keys(props).forEach(function (key) {
      var cleanKey = String(key || '').trim();
      var value = props[key];
      if (value === null || value === undefined || value === '') return;
      if (cleanKey.charAt(0) === '_') return;
      if (/^split[\s-]*paket[\s-]*id$/i.test(cleanKey)) return;
      if (/^split[\s-]*package[\s-]*id$/i.test(cleanKey)) return;
      if (/^split[\s-]*ursprung$/i.test(cleanKey)) return;
      if (/^split[\s-]*origin$/i.test(cleanKey)) return;
      out[key] = value;
    });
    return out;
  }

  function cartLineChangePayloadForItem(item, lineKey, lineNumber, properties) {
    var lineIdx = parseInt(String(lineNumber || '0'), 10) - 1;
    var payload = {
      quantity: item && item.quantity ? item.quantity : 1,
      properties: properties || {}
    };
    if (lineIdx >= 0) payload.line = lineIdx + 1;
    else if (lineKey) payload.id = lineKey;
    return payload;
  }

  function rebuildCartLineWithProperties(item, lineKey, lineNumber, properties) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var addItem = {
      id: item.variant_id,
      quantity: item.quantity || 1,
      properties: properties || {}
    };
    try {
      var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id;
      if (sellingPlan) addItem.selling_plan = sellingPlan;
    } catch (e) { /* no selling plan */ }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [addItem] })
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t || 'Cart-Zeile konnte nicht neu aufgebaut werden.'); });
      if (!lineKey && !lineNumber) return null;
      var removePayload = { quantity: 0 };
      if (lineKey) {
        removePayload.id = lineKey;
      } else {
        var removeLineIdx = parseInt(String(lineNumber || '0'), 10) - 1;
        if (removeLineIdx >= 0) removePayload.line = removeLineIdx + 1;
      }
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(removePayload)
      }).then(function (removeResponse) {
        if (!removeResponse.ok) return removeResponse.text().then(function (t) { throw new Error(t || 'Alte Split-Zeile konnte nicht entfernt werden.'); });
      });
    });
  }

  function sortCartRowsByPackage(order) {
    try {
      var tbody = document.querySelector('#main-cart-items tbody');
      if (!tbody || !lastCart || !lastCart.items) return;
      var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr.cart-item'));
      if (!rows.length) return;
      var original = new Map();
      var selectedGroups = selectedGroupMap();
      rows.forEach(function (row, i) { original.set(row, i); });
      rows.sort(function (a, b) {
        var ia = cartLineIndexForInput(a.querySelector('input[name="updates[]"]') || a, original.get(a) || 0);
        var ib = cartLineIndexForInput(b.querySelector('input[name="updates[]"]') || b, original.get(b) || 0);
        var itemA = lastCart.items[ia] || {};
        var itemB = lastCart.items[ib] || {};
        var ga = groupForCartItem(itemA);
        var gb = groupForCartItem(itemB);
        var ea = isExtraVersandItem(itemA);
        var eb = isExtraVersandItem(itemB);
        var ta = ea ? (extraSelectedByGroups(itemA, selectedGroups) ? extraVersandGroupIdFromItem(itemA) : '__GENKIDAMA_INACTIVE_EXTRA__') : (isRealCartItemSelected(itemA) ? ga : '__GENKIDAMA_HELD__');
        var tb = eb ? (extraSelectedByGroups(itemB, selectedGroups) ? extraVersandGroupIdFromItem(itemB) : '__GENKIDAMA_INACTIVE_EXTRA__') : (isRealCartItemSelected(itemB) ? gb : '__GENKIDAMA_HELD__');
        var pa = order.indexOf(ta);
        var pb = order.indexOf(tb);
        if (ta === '__GENKIDAMA_HELD__') pa = 9998;
        if (tb === '__GENKIDAMA_HELD__') pb = 9998;
        if (pa < 0) pa = 9999;
        if (pb < 0) pb = 9999;
        if (pa !== pb) return pa - pb;
        if (ea !== eb) return ea ? 1 : -1;
        return (original.get(a) || 0) - (original.get(b) || 0);
      });
      rows.forEach(function (row) { tbody.appendChild(row); });
    } catch (e) { /* fail-open */ }
  }

  function ensurePackageFrameStyles() {
    if (document.getElementById('genkidama-package-frame-styles')) return;
    var style = document.createElement('style');
    style.id = 'genkidama-package-frame-styles';
    style.textContent = [
      '#main-cart-items .cart-items{border-collapse:separate!important;border-spacing:0 0!important;}',
      '#main-cart-items .cart-items thead{display:none;}',
      '#main-cart-items .cart-items tbody{display:block;}',
      '#main-cart-items tr.genkidama-package-head-row{display:block;margin:18px 0 0;}',
      '#main-cart-items tr.genkidama-package-head-row>td{display:block!important;padding:0!important;border:0!important;background:transparent!important;}',
      '#main-cart-items .genkidama-package-head{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:14px 18px;border:1px solid rgba(222,215,207,.95);border-bottom:0;border-radius:18px 18px 0 0;background:linear-gradient(90deg,#fffaf3,rgba(255,250,243,0));font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
      '#main-cart-items .genkidama-package-title{display:flex;align-items:center;gap:10px;min-width:0;font-weight:700;color:#101820;font-size:1.45rem;}',
      '#main-cart-items .genkidama-package-dot{width:9px;height:9px;border-radius:50%;background:#118044;flex:0 0 auto;}',
      '#main-cart-items .genkidama-package-meta{color:#697077;font-size:1.2rem;text-align:right;white-space:nowrap;}',
      '#main-cart-items tr.genkidama-package-row.cart-item{margin:0!important;}',
      '#main-cart-items tr.genkidama-package-row{display:grid!important;grid-template-columns:92px minmax(0,1fr) 156px 120px;gap:18px;align-items:center;padding:18px;border-left:1px solid rgba(222,215,207,.95);border-right:1px solid rgba(222,215,207,.95);border-bottom:1px solid rgba(222,215,207,.95);background:#fff;font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
      '#main-cart-items tr.genkidama-package-row>td{display:block!important;padding:0!important;border:0!important;background:transparent!important;}',
      '#main-cart-items tr.genkidama-package-row .cart-item__media{grid-column:1;}',
      '#main-cart-items tr.genkidama-package-row .cart-item__details{grid-column:2;min-width:0;}',
      '#main-cart-items tr.genkidama-package-row .cart-item__name{font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;font-size:1.7rem;line-height:1.22;font-weight:700;letter-spacing:0;}',
      '#main-cart-items tr.genkidama-package-row .product-option{color:#697077;font-size:1.3rem;margin-top:6px;}',
      '#main-cart-items tr.genkidama-package-row .cart-item__totals.medium-hide{display:none!important;}',
      '#main-cart-items tr.genkidama-package-row .cart-item__quantity{grid-column:3;}',
      '#main-cart-items tr.genkidama-package-row .cart-item__quantity-wrapper{display:flex;align-items:center;justify-content:flex-end;gap:16px;}',
      '#main-cart-items tr.genkidama-package-row .cart-item__totals.small-hide{grid-column:4;text-align:right;font-weight:700;padding-right:14px!important;}',
      '#main-cart-items tr.genkidama-package-row .cart-item__image-container, #main-cart-items tr.genkidama-package-row .cart-item__image{width:76px!important;height:76px!important;object-fit:contain;border-radius:12px;}',
      '#main-cart-items tr.genkidama-package-row .quantity{height:42px;border-radius:10px;}',
      '#main-cart-items tr.genkidama-package-extra{grid-template-columns:92px minmax(0,1fr) 156px 120px;background:#f6efe6;padding-top:16px;padding-bottom:18px;}',
      '#main-cart-items tr.genkidama-package-extra .cart-item__details{grid-column:2;}',
      '#main-cart-items tr.genkidama-package-extra .cart-item__quantity{grid-column:3;}',
      '#main-cart-items tr.genkidama-package-extra .cart-item__totals.small-hide{grid-column:4;}',
      '#main-cart-items tr.genkidama-package-extra .cart-item__media{display:grid!important;place-items:center;}',
      '#main-cart-items tr.genkidama-package-extra .cart-item__media:before{content:"EV";display:grid;place-items:center;width:42px;height:42px;border-radius:50%;background:#10251f;color:#fff;font-size:1.05rem;font-weight:700;}',
      '#main-cart-items tr.genkidama-package-extra .cart-item__media>*{display:none!important;}',
      '#main-cart-items tr.genkidama-package-extra .cart-item__name{font-weight:700;color:#7c2d12;letter-spacing:0;font-size:1.6rem;}',
      '#main-cart-items tr.genkidama-package-last{border-radius:0 0 18px 18px;}',
      '#main-cart-items tr.genkidama-package-row:has(+ tr.genkidama-extra-versand-row){border-radius:0;}',
      '#main-cart-items tr.genkidama-extra-service-item .quantity-popover-container{display:none!important;}',
      '#main-cart-items tr.genkidama-extra-service-item .cart-item__quantity-wrapper{justify-content:center;}',
      '#main-cart-items .genkidama-service-pill{display:inline-flex;align-items:center;justify-content:center;min-width:86px;padding:8px 12px;border-radius:999px;background:#edf7f1;color:#1f5135;font-weight:700;font-size:1.15rem;letter-spacing:0;}',
      '#main-cart-items .genkidama-checkout-select-wrap{display:inline-flex;align-items:center;gap:8px;margin:0 0 8px;padding:6px 10px;border:1px solid #bbf7d0;border-radius:999px;background:#f0fdf4;color:#166534;font-size:1.15rem;font-weight:800;line-height:1.15;}',
      '#main-cart-items .genkidama-checkout-select{width:16px;height:16px;margin:0;accent-color:#15803d;cursor:pointer;}',
      '#main-cart-items .genkidama-checkout-held{opacity:.58;background:#f8f8f8!important;}',
      '#main-cart-items .genkidama-checkout-held .genkidama-checkout-select-wrap{border-color:#fed7aa;background:#fff7ed;color:#9a3412;}',
      '#main-cart-items .genkidama-checkout-held .cart-item__name{color:#697077!important;}',
      '#main-cart-items .genkidama-package-head-row.genkidama-held-head .genkidama-package-head{border-color:#fed7aa;background:linear-gradient(90deg,#fff7ed,rgba(255,247,237,0));}',
      '#main-cart-items .genkidama-package-head-row.genkidama-held-head .genkidama-package-dot{background:#d97706;}',
      '.genkidama-checkout-selection-note{margin:0 0 12px;padding:11px 13px;border:1px solid #fed7aa;border-radius:12px;background:#fff7ed;color:#9a3412;font-size:1.25rem;font-weight:800;line-height:1.35;text-align:left;}',
      '.genkidama-held-checkout-restore{display:flex;align-items:center;justify-content:space-between;gap:14px;margin:0 0 18px;padding:14px 16px;border:1px solid #fed7aa;border-radius:14px;background:#fff7ed;color:#7c2d12;font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
      '.genkidama-held-checkout-copy{display:flex;flex-direction:column;gap:3px;font-size:1.25rem;line-height:1.35;}',
      '.genkidama-held-checkout-copy strong{font-size:1.38rem;color:#9a3412;}',
      '.genkidama-held-checkout-btn{flex:0 0 auto;border-radius:10px!important;background:#10251f!important;color:#fff!important;border:0!important;padding:11px 14px!important;font-weight:800!important;}',
      'tr.genkidama-extra-service-item .quantity-popover-container{display:none!important;}',
      'tr.genkidama-extra-service-item .cart-item__quantity-wrapper{justify-content:center;}',
      '.genkidama-service-pill{display:inline-flex;align-items:center;justify-content:center;min-width:86px;padding:8px 12px;border-radius:999px;background:#edf7f1;color:#1f5135;font-weight:700;font-size:1.15rem;letter-spacing:0;}',
      '#main-cart-items tr.genkidama-extra-versand-row{display:block;margin:0 0 18px;}',
      '#main-cart-items tr.genkidama-extra-versand-row>td{display:block!important;padding:0!important;border:0!important;background:transparent!important;}',
      '#main-cart-items .genkidama-extra-versand-box{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;margin:0;padding:13px 16px;border-left:1px solid rgba(222,215,207,.95);border-right:1px solid rgba(222,215,207,.95);border-bottom:1px solid rgba(222,215,207,.95);border-top:0;border-radius:0 0 18px 18px;background:#fff7ed;}',
      '#main-cart-items .genkidama-extra-versand-copy{display:flex;flex-direction:column;gap:2px;color:#c46a1b;font-size:1.25rem;line-height:1.35;font-weight:600;}',
      '#main-cart-items .genkidama-extra-versand-title{font-weight:800;color:#7c2d12;}',
      '#main-cart-items .genkidama-extra-versand-btn{min-width:260px;background:#10251f!important;color:#fff!important;border:0!important;border-radius:10px!important;padding:12px 16px!important;font-weight:700!important;cursor:pointer;letter-spacing:0!important;}',
      '#main-cart-items .genkidama-package-action{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-top:7px;}',
      '#main-cart-items .genkidama-package-action-select{max-width:260px;min-height:32px;padding:5px 28px 5px 9px;border:1px solid #86efac;border-radius:8px;background:#fff;color:#166534;font-size:1.12rem;font-weight:700;}',
      '#main-cart-items .genkidama-split-package-btn{display:flex;align-items:center;justify-content:center;width:fit-content;max-width:100%;padding:6px 10px;border:1px solid #d97706;border-radius:8px;background:#fffaf3;color:#9a3412;font-size:1.12rem;font-weight:800;line-height:1.1;cursor:pointer;white-space:normal;text-align:center;}',
      '#main-cart-items .genkidama-split-package-btn.genkidama-merge-package-btn{border-color:#16a34a;background:#f0fdf4;color:#15803d;}',
      '#main-cart-items .genkidama-split-package-btn:hover{background:#ffedd5;color:#7c2d12;}',
      '#main-cart-items .genkidama-split-package-btn.genkidama-merge-package-btn:hover{background:#dcfce7;color:#166534;}',
      '@media (max-width:749px){#main-cart-items{margin:0 1.2rem;}#main-cart-items tr.genkidama-package-head-row{margin:14px 0 0;}#main-cart-items .genkidama-package-head{align-items:flex-start;flex-direction:column;gap:6px;padding:12px 14px;}#main-cart-items .genkidama-package-title{font-size:1.35rem;}#main-cart-items .genkidama-package-meta{text-align:left;white-space:normal;font-size:1.1rem;}#main-cart-items tr.genkidama-package-row{grid-template-columns:74px minmax(0,1fr);gap:8px 12px;align-items:start;padding:14px;}#main-cart-items tr.genkidama-package-row .cart-item__media{grid-column:1;grid-row:1 / span 3;align-self:start;margin:0!important;padding:0!important;}#main-cart-items tr.genkidama-package-row .cart-item__details{grid-column:2;grid-row:1;min-width:0;align-self:start;}#main-cart-items tr.genkidama-package-row .cart-item__name{font-size:1.45rem;line-height:1.22;font-weight:700;}#main-cart-items tr.genkidama-package-row .product-option{font-size:1.15rem;margin-top:5px;}#main-cart-items tr.genkidama-package-row .cart-item__quantity{grid-column:2;grid-row:2;width:100%;margin:8px 0 0;}#main-cart-items tr.genkidama-package-row .cart-item__quantity-wrapper{display:flex!important;flex-direction:row!important;align-items:center!important;justify-content:flex-start!important;gap:12px!important;width:100%;}#main-cart-items tr.genkidama-package-row .quantity{width:132px;min-height:40px;height:40px;flex:0 0 auto;}#main-cart-items tr.genkidama-package-row .cart-remove-button,#main-cart-items tr.genkidama-package-row cart-remove-button{width:32px;height:32px;margin:0!important;display:flex!important;align-items:center!important;justify-content:center!important;}#main-cart-items tr.genkidama-package-row .cart-item__totals.small-hide{display:block!important;grid-column:2;grid-row:3;text-align:left;padding-right:0!important;margin-top:4px;font-size:1.45rem;}#main-cart-items tr.genkidama-package-row .cart-item__image-container,#main-cart-items tr.genkidama-package-row .cart-item__image{width:64px!important;height:64px!important;object-fit:contain;border-radius:12px;}#main-cart-items tr.genkidama-package-extra{grid-template-columns:54px minmax(0,1fr);gap:8px 12px;padding:14px;background:#f6efe6;}#main-cart-items tr.genkidama-package-extra .cart-item__media{grid-column:1;grid-row:1 / span 3;align-self:start;margin:0!important;padding:0!important;}#main-cart-items tr.genkidama-package-extra .cart-item__media:before{width:40px;height:40px;font-size:.95rem;}#main-cart-items tr.genkidama-package-extra .cart-item__details{grid-column:2;grid-row:1;}#main-cart-items tr.genkidama-package-extra .cart-item__quantity{grid-column:2;grid-row:2;width:100%;margin-top:6px;}#main-cart-items tr.genkidama-package-extra .cart-item__totals.small-hide{grid-column:2;grid-row:3;text-align:left;padding-right:0!important;margin-top:4px;}#main-cart-items .genkidama-service-pill{min-width:76px;padding:7px 10px;font-size:1.05rem;}#main-cart-items .genkidama-extra-versand-box{align-items:stretch;flex-direction:column;padding:13px 14px;}#main-cart-items .genkidama-extra-versand-copy{font-size:1.2rem;}#main-cart-items .genkidama-extra-versand-btn{width:100%;min-width:0;}.genkidama-held-checkout-restore{align-items:stretch;flex-direction:column;margin:0 1.2rem 14px;}.genkidama-held-checkout-btn{width:100%;}}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function decorateExtraVersandRows() {
    try {
      ensurePackageFrameStyles();
      var rows = Array.prototype.slice.call(document.querySelectorAll('#main-cart-items tr.cart-item, cart-drawer tr.cart-item'));
      rows.forEach(function (row, fallbackIdx) {
        var input = row.querySelector('input[name="updates[]"]');
        var idx = input ? cartLineIndexForInput(input, fallbackIdx) : fallbackIdx;
        var item = lastCart && lastCart.items ? lastCart.items[idx] : null;
        var isExtra = row.classList.contains('genkidama-extra-service-item') ||
          (item && (item.handle === EXTRA_VERSAND_HANDLE || Number(item.variant_id) === EXTRA_VERSAND_VARIANT_ID));
        if (!isExtra) return;
        row.classList.add('genkidama-extra-service-item');
        var qtyCell = row.querySelector('.cart-item__quantity');
        if (!qtyCell || qtyCell.querySelector('.genkidama-service-pill')) return;
        var wrapper = qtyCell.querySelector('.cart-item__quantity-wrapper') || qtyCell;
        var pill = document.createElement('span');
        pill.className = 'genkidama-service-pill';
        pill.textContent = 'Service';
        wrapper.insertBefore(pill, wrapper.firstChild);
      });
    } catch (e) { /* fail-open */ }
  }

  function applyPackageFrames(order) {
    try {
      ensurePackageFrameStyles();
      if (!lastCart || !lastCart.items) return;
      document.querySelectorAll('#main-cart-items tr.genkidama-package-head-row').forEach(function (row) { row.remove(); });
      var rows = Array.prototype.slice.call(document.querySelectorAll('#main-cart-items tr.cart-item'));
      var selectedGroups = selectedGroupMap();
      var smallCheckoutBasisUsed = false;
      rows.forEach(function (row) {
        row.classList.remove('genkidama-package-row', 'genkidama-package-framed', 'genkidama-package-first', 'genkidama-package-last', 'genkidama-package-extra');
        row.removeAttribute('data-genkidama-package-frame');
      });
      (order || []).forEach(function (groupKey, groupIndex) {
        var groupRows = [];
        var realCount = 0;
        var realSum = 0;
        var hasExtra = false;
        rows.forEach(function (row, fallbackIdx) {
          var input = row.querySelector('input[name="updates[]"]');
          var idx = cartLineIndexForInput(input || row, fallbackIdx);
          var item = lastCart.items[idx];
          if (!item) return;
          var itemGroup = groupForCartItem(item);
          var isExtra = isExtraVersandItem(item);
          if (isExtra) {
            if (!extraSelectedByGroups(item, selectedGroups)) return;
            itemGroup = extraVersandGroupIdFromItem(item);
          } else if (!isRealCartItemSelected(item)) {
            return;
          }
          if (itemGroup !== groupKey) return;
          row.classList.add('genkidama-package-row', 'genkidama-package-framed');
          row.dataset.genkidamaPackageFrame = String(groupIndex + 1);
          if (isExtra) {
            row.classList.add('genkidama-package-extra');
            hasExtra = true;
          } else {
            realCount += 1;
            realSum += (Number(item.final_line_price || 0) || ((Number(item.final_price || item.price || 0) || 0) * (Number(item.quantity || 0) || 0)));
          }
          groupRows.push(row);
        });
        if (!groupRows.length) return;
        groupRows[0].classList.add('genkidama-package-first');
        groupRows[groupRows.length - 1].classList.add('genkidama-package-last');
        var headRow = document.createElement('tr');
        headRow.className = 'genkidama-package-head-row';
        var cell = document.createElement('td');
        cell.colSpan = 5;
        var head = document.createElement('div');
        head.className = 'genkidama-package-head';
        var title = document.createElement('div');
        title.className = 'genkidama-package-title';
        var dot = document.createElement('span');
        dot.className = 'genkidama-package-dot';
        var titleText = document.createElement('span');
        titleText.textContent = 'Paket ' + (groupIndex + 1) + ' - ' + (gruppenNamen[groupKey] || 'Versandgruppe');
        title.appendChild(dot);
        title.appendChild(titleText);
        var meta = document.createElement('div');
        meta.className = 'genkidama-package-meta';
        var sumText = formatEuroCent(realSum).replace(' EUR', ' EUR');
        var statusText = hasExtra ? 'Extra-Versand aktiv' : 'bereit';
        if (!hasExtra && realSum < GRUPPEN_MINDESTWERT_CENT) {
          if (order.length >= 2 && smallCheckoutBasisUsed) {
            statusText = 'Extra-Versand fehlt';
          } else {
            statusText = 'Versand im Checkout';
            smallCheckoutBasisUsed = true;
          }
        }
        meta.textContent = realCount + ' Artikel - ' + sumText + ' - ' + statusText;
        head.appendChild(title);
        head.appendChild(meta);
        cell.appendChild(head);
        headRow.appendChild(cell);
        if (groupRows[0].parentNode) groupRows[0].parentNode.insertBefore(headRow, groupRows[0]);
      });
      var heldRows = [];
      rows.forEach(function (row, fallbackIdx) {
        var input = row.querySelector('input[name="updates[]"]');
        var idx = cartLineIndexForInput(input || row, fallbackIdx);
        var item = lastCart.items[idx];
        if (!item || isExtraVersandItem(item) || isRealCartItemSelected(item)) return;
        row.classList.add('genkidama-package-row', 'genkidama-package-framed', 'genkidama-checkout-held');
        row.dataset.genkidamaPackageFrame = 'held';
        heldRows.push(row);
      });
      if (heldRows.length) {
        heldRows[0].classList.add('genkidama-package-first');
        heldRows[heldRows.length - 1].classList.add('genkidama-package-last');
        var heldHeadRow = document.createElement('tr');
        heldHeadRow.className = 'genkidama-package-head-row genkidama-held-head';
        var heldCell = document.createElement('td');
        heldCell.colSpan = 5;
        var heldHead = document.createElement('div');
        heldHead.className = 'genkidama-package-head';
        var heldTitle = document.createElement('div');
        heldTitle.className = 'genkidama-package-title';
        var heldDot = document.createElement('span');
        heldDot.className = 'genkidama-package-dot';
        var heldText = document.createElement('span');
        heldText.textContent = 'Spaeter kaufen - bleibt im Warenkorb';
        heldTitle.appendChild(heldDot);
        heldTitle.appendChild(heldText);
        var heldMeta = document.createElement('div');
        heldMeta.className = 'genkidama-package-meta';
        heldMeta.textContent = heldRows.length + ' Artikel - nicht in diesem Checkout';
        heldHead.appendChild(heldTitle);
        heldHead.appendChild(heldMeta);
        heldCell.appendChild(heldHead);
        heldHeadRow.appendChild(heldCell);
        if (heldRows[0].parentNode) heldRows[0].parentNode.insertBefore(heldHeadRow, heldRows[0]);
      }
    } catch (e) { /* fail-open */ }
  }

  function lineHintFor(input, create) {
    // Boss (05.08.): Der Warntext steht in der ARTIKEL-Spalte, als dritte
    // Zeile unter Titel und Preis (Artikel / Preis / Warntext) - nicht
    // neben dem Mengenfeld eingequetscht.
    var row = input.closest('.cart-item') || input.closest('tr') || input.parentElement;
    if (!row) return null;
    var box = row.querySelector('.cart-item__details') || row.querySelector('td') || row;
    var hint = row.querySelector('.genkidama-max-line-hint');
    if (!hint && create) {
      hint = document.createElement('div');
      hint.className = 'genkidama-max-line-hint';
      hint.setAttribute('style', 'color:#d92d20;font-size:1.3rem;font-weight:700;margin-top:6px;line-height:1.3;');
      box.appendChild(hint);
    }
    return hint;
  }

  function lineBadgeFor(input) {
    // PAKET-ABZEICHEN (05.08., Boss: "muss ja sehen welches 09.2026 ist"):
    // jede Warenkorb-Zeile zeigt, in welchem Paket sie reist.
    var row = input.closest('.cart-item') || input.closest('tr') || input.parentElement;
    if (!row) return null;
    var box = row.querySelector('.cart-item__details') || row.querySelector('td') || row;
    var badge = row.querySelector('.genkidama-paket-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'genkidama-paket-badge';
      badge.setAttribute('style', 'display:block;width:fit-content;max-width:100%;margin-top:6px;padding:3px 10px;border:1px solid #c8e6c9;border-radius:999px;background:#f1fbf2;color:#2e7d32;font-size:1.15rem;font-weight:700;line-height:1.25;');
      box.appendChild(badge);
    }
    return badge;
  }

  var letzteNotiz = null;
  var notizGesperrtBis = 0;
  var orphanCleanupRunning = false;
  var packageActionHoldUntil = 0;

  function packageActionIsActive() {
    var active = document.activeElement;
    if (active && active.closest && active.closest('.genkidama-package-action')) return true;
    return (new Date()).getTime() < packageActionHoldUntil;
  }

  function schreibeVersandgruppenNotiz(text) {
    // BACKEND-SICHT (05.08., Boss): Cart-Attribut "Versandgruppen" wandert
    // automatisch in die Bestellung (Shopify-Admin: Zusaetzliche Details).
    try {
      if (!text || text === letzteNotiz) return;
      var vorhanden = (lastCart && lastCart.attributes) ? lastCart.attributes['Versandgruppen'] : null;
      if (vorhanden === text) { letzteNotiz = text; return; }
      var jetzt = (new Date()).getTime();
      if (jetzt < notizGesperrtBis) return;
      notizGesperrtBis = jetzt + 4000;
      letzteNotiz = text;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { Versandgruppen: text } })
      }).catch(function () { /* fail-open */ });
    } catch (e) { /* fail-open */ }
  }

  function genkiSpruch(text) {
    try {
      var alt = document.getElementById('genkidama-spruch-toast');
      if (alt) alt.remove();
      var t = document.createElement('div');
      t.id = 'genkidama-spruch-toast';
      t.setAttribute('style', 'position:fixed;left:50%;bottom:40px;transform:translateX(-50%);background:#7f1d1d;color:#fff;padding:14px 22px;border-radius:12px;font-size:1.4rem;font-weight:700;z-index:99999;box-shadow:0 8px 24px rgba(0,0,0,.4);max-width:90vw;text-align:center;line-height:1.4;');
      t.textContent = text;
      document.body.appendChild(t);
      setTimeout(function () { try { t.remove(); } catch (e) {} }, 7000);
    } catch (e) { /* fail-open */ }
  }

  function checkoutButtons() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '#checkout, button[name="checkout"], input[name="checkout"]'
    ));
  }

  function formatEuroCent(cent) {
    return (Math.max(0, cent || 0) / 100).toFixed(2).replace('.', ',') + ' EUR';
  }

  function extraVersandGroupIdFromItem(item) {
    var props = (item && item.properties) || {};
    return String(props['_Paket-ID'] || props['_Paket ID'] || props['_Versandgruppe-ID'] || props['Paket-ID'] || props['Paket ID'] || props['Versandgruppe-ID'] || '').trim();
  }

  function migrateVisibleExtraVersandPackageIds(cart) {
    if (window.__genkidamaExtraShippingPropertyMigration) return false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i] || {};
      if (item.handle !== EXTRA_VERSAND_HANDLE && Number(item.variant_id) !== EXTRA_VERSAND_VARIANT_ID) continue;
      var props = item.properties || {};
      var visibleId = String(props['Paket-ID'] || props['Paket ID'] || props['Versandgruppe-ID'] || '').trim();
      var hasVisibleExtraMeta = !!(props['Paket'] || props['Versandgruppe'] || props['Gruppen-Warenwert'] || props['Fehlbetrag bis 150 EUR'] || props['Betroffene Artikel']);
      if (!visibleId && !hasVisibleExtraMeta) continue;
      var cleanProps = {};
      Object.keys(props).forEach(function (key) {
        if (key === 'Paket-ID' || key === 'Paket ID' || key === 'Versandgruppe-ID') return;
        if (key === 'Paket' || key === 'Versandgruppe' || key === 'Gruppen-Warenwert' || key === 'Fehlbetrag bis 150 EUR' || key === 'Betroffene Artikel') return;
        cleanProps[key] = props[key];
      });
      if (!cleanProps['_Paket-ID']) cleanProps['_Paket-ID'] = visibleId;
      if (props['Paket'] && !cleanProps['_Paket']) cleanProps['_Paket'] = String(props['Paket']);
      if (props['Versandgruppe'] && !cleanProps['_Versandgruppe']) cleanProps['_Versandgruppe'] = String(props['Versandgruppe']);
      if (props['Gruppen-Warenwert'] && !cleanProps['_Gruppen-Warenwert']) cleanProps['_Gruppen-Warenwert'] = String(props['Gruppen-Warenwert']);
      if (props['Fehlbetrag bis 150 EUR'] && !cleanProps['_Fehlbetrag bis 150 EUR']) cleanProps['_Fehlbetrag bis 150 EUR'] = String(props['Fehlbetrag bis 150 EUR']);
      if (props['Betroffene Artikel'] && !cleanProps['_Betroffene Artikel']) cleanProps['_Betroffene Artikel'] = String(props['Betroffene Artikel']);
      window.__genkidamaExtraShippingPropertyMigration = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: i + 1,
          quantity: item.quantity || 1,
          properties: cleanProps
        })
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        window.__genkidamaExtraShippingPropertyMigration = false;
      });
      return true;
    }
    return false;
  }

  function extraVersandGroupsInCart(cart) {
    var found = {};
    ((cart && cart.items) || []).forEach(function (item) {
      if (item.handle !== EXTRA_VERSAND_HANDLE && Number(item.variant_id) !== EXTRA_VERSAND_VARIANT_ID) return;
      var gid = extraVersandGroupIdFromItem(item);
      if (gid) found[gid] = true;
    });
    return found;
  }

  function updateExtraVersandVisibleTitles(order) {
    try {
      if (!lastCart || !lastCart.items) return;
      var rows = Array.prototype.slice.call(document.querySelectorAll('#main-cart-items tr.cart-item'));
      rows.forEach(function (row, fallbackIdx) {
        var input = row.querySelector('input[name="updates[]"]');
        var idx = cartLineIndexForInput(input || row, fallbackIdx);
        var item = lastCart.items[idx];
        if (!item || (item.handle !== EXTRA_VERSAND_HANDLE && Number(item.variant_id) !== EXTRA_VERSAND_VARIANT_ID)) return;
        var gid = extraVersandGroupIdFromItem(item);
        if (!gid) return;
        var nr = (order || []).indexOf(gid) + 1;
        var title = row.querySelector('.cart-item__name');
        if (title && nr > 0) {
          title.textContent = 'Extra-Versand fuer Paket ' + nr;
        }
      });
    } catch (e) { /* fail-open */ }
  }

  function cleanupOrphanExtraVersand(activeGroups, groupSums) {
    try {
      if (orphanCleanupRunning || !lastCart || !lastCart.items) return;
      var active = {};
      var realGroups = [];
      (activeGroups || []).forEach(function (g) {
        if (!g || active[g]) return;
        active[g] = true;
        realGroups.push(g);
      });
      var extraNoLongerNeeded = realGroups.length < 2;
      var orphan = null;
      for (var i = 0; i < lastCart.items.length; i++) {
        var item = lastCart.items[i];
        if (item.handle !== EXTRA_VERSAND_HANDLE && Number(item.variant_id) !== EXTRA_VERSAND_VARIANT_ID) continue;
        var gid = extraVersandGroupIdFromItem(item);
        var groupReachedMinimum = gid && groupSums && Number(groupSums[gid] || 0) >= GRUPPEN_MINDESTWERT_CENT;
        if (extraNoLongerNeeded || !gid || !active[gid] || groupReachedMinimum) {
          orphan = item;
          break;
        }
      }
      if (!orphan || !orphan.key) return;
      orphanCleanupRunning = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: orphan.key, quantity: 0 })
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        orphanCleanupRunning = false;
      });
    } catch (e) {
      orphanCleanupRunning = false;
    }
  }

  function removeExtraVersandPanel() {
    var panel = document.getElementById('genkidama-extra-versand-panel');
    if (panel) panel.remove();
    document.querySelectorAll('.genkidama-extra-versand-row').forEach(function (row) { row.remove(); });
  }

  function shortTitle(text) {
    text = String(text || '').replace(/\s+/g, ' ').trim();
    return text.length > 90 ? text.slice(0, 87) + '...' : text;
  }

  function renderExtraVersandPanel(groups) {
    removeExtraVersandPanel();
    ensurePackageFrameStyles();
    var tbody = document.querySelector('#main-cart-items tbody');
    if (!tbody || !groups || !groups.length || !lastCart || !lastCart.items) return;
    var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr.cart-item'));
    groups.forEach(function (g) {
      var lastRow = null;
      rows.forEach(function (row, fallbackIdx) {
        var idx = cartLineIndexForInput(row.querySelector('input[name="updates[]"]') || row, fallbackIdx);
        var item = lastCart.items[idx];
        if (!item || isExtraVersandItem(item) || !isRealCartItemSelected(item)) return;
        if (groupForCartItem(item) === g.gruppe) lastRow = row;
      });
      if (!lastRow || !lastRow.parentNode) return;
      var actionRow = document.createElement('tr');
      actionRow.className = 'genkidama-extra-versand-row';
      var cell = document.createElement('td');
      cell.colSpan = 4;
      var box = document.createElement('div');
      box.className = 'genkidama-extra-versand-box';
      var copy = document.createElement('div');
      copy.className = 'genkidama-extra-versand-copy';
      var title = document.createElement('span');
      title.className = 'genkidama-extra-versand-title';
      title.textContent = 'Paket unter 150 EUR';
      var sub = document.createElement('span');
      sub.textContent = (g.paketLabel || g.paketKurz) + ' braucht Extra-Versand, weil dieses Paket unter 150 EUR liegt und der Checkout sonst keinen Versand berechnet.';
      copy.appendChild(title);
      copy.appendChild(sub);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button genkidama-extra-versand-btn';
      btn.dataset.group = g.gruppe;
      btn.textContent = 'Extra-Versand fuer ' + g.paketKurz + ' hinzufuegen';
      box.appendChild(copy);
      box.appendChild(btn);
      cell.appendChild(box);
      actionRow.appendChild(cell);
      lastRow.parentNode.insertBefore(actionRow, lastRow.nextSibling);
    });
  }

  function removeSplitButtons() {
    document.querySelectorAll('.genkidama-split-package-btn, .genkidama-merge-package-btn, .genkidama-package-action').forEach(function (el) { el.remove(); });
  }

  function originForGroupInCart(groupKey, zeilen) {
    if (!groupKey) return '';
    if (String(groupKey).indexOf('SPLIT:') !== 0) return groupKey;
    var origin = '';
    (zeilen || []).forEach(function (z) {
      if (origin || !z || z.gruppe !== groupKey) return;
      var item = cartItemForInput(z.input, 0);
      origin = splitOriginFromItem(item) || groupByVariant[item && item.variant_id] || '';
    });
    return origin;
  }

  function compatiblePackageTargetsForSplit(item, currentGroup, zeilen, reihenfolge) {
    var origin = splitOriginFromItem(item) || groupByVariant[item && item.variant_id] || '';
    var targets = [];
    if (!origin || String(origin).indexOf('TCG:') === 0) return targets;
    (reihenfolge || []).forEach(function (groupKey) {
      if (!groupKey || groupKey === currentGroup) return;
      if (String(groupKey).indexOf('EXTRA:') === 0) return;
      if (originForGroupInCart(groupKey, zeilen) !== origin) return;
      targets.push({
        group: groupKey,
        label: 'Paket ' + ((reihenfolge || []).indexOf(groupKey) + 1) + ': ' + (gruppenNamen[groupKey] || gruppenNamen[origin] || 'Versandgruppe')
      });
    });
    if (!targets.length) {
      targets.push({
        group: origin,
        label: gruppenNamen[origin] || 'Original-Paket'
      });
    }
    return targets;
  }

  function renderSplitButtons(zeilen, reihenfolge) {
    try {
      if (packageActionIsActive()) return;
      removeSplitButtons();
      if (!lastCart || !lastCart.items || !zeilen || !zeilen.length) return;
      var counts = {};
      zeilen.forEach(function (z) {
        if (!z || z.qty <= 0) return;
        counts[z.gruppe] = (counts[z.gruppe] || 0) + 1;
      });
      zeilen.forEach(function (z) {
        if (!z || z.qty <= 0) return;
        var item = cartItemForInput(z.input, 0);
        if (!item || item.handle === EXTRA_VERSAND_HANDLE || Number(item.variant_id) === EXTRA_VERSAND_VARIANT_ID) return;
        var row = z.input.closest('.cart-item') || z.input.closest('tr') || z.input.parentElement;
        var box = row && (row.querySelector('.cart-item__details') || row.querySelector('td') || row);
        if (!box || box.querySelector('.genkidama-package-action') || box.querySelector('.genkidama-split-package-btn')) return;
        var splitId = splitPackageIdFromItem(item);
        var lineNumber = cartLineIndexForInput(z.input, 0) + 1;
        var nr = (reihenfolge || []).indexOf(z.gruppe) + 1;
        var wrap = document.createElement('div');
        wrap.className = 'genkidama-package-action';
        if (splitId) {
          var targets = compatiblePackageTargetsForSplit(item, z.gruppe, zeilen, reihenfolge);
          if (targets.length) {
            var select = document.createElement('select');
            select.className = 'genkidama-package-action-select';
            targets.forEach(function (target) {
              var opt = document.createElement('option');
              opt.value = target.group;
              opt.textContent = target.label;
              select.appendChild(opt);
            });
            wrap.appendChild(select);
            var mergeBtn = document.createElement('button');
            mergeBtn.type = 'button';
            mergeBtn.className = 'genkidama-split-package-btn genkidama-merge-package-btn';
            mergeBtn.textContent = 'Verbinden';
            mergeBtn.dataset.cartLineKey = item.key || '';
            mergeBtn.dataset.cartLineNumber = String(lineNumber > 0 ? lineNumber : '');
            wrap.appendChild(mergeBtn);
          }
          if (counts[z.gruppe] >= 2) {
            var splitAgainBtn = document.createElement('button');
            splitAgainBtn.type = 'button';
            splitAgainBtn.className = 'genkidama-split-package-btn';
            splitAgainBtn.textContent = 'Als eigenes Paket teilen';
            splitAgainBtn.dataset.cartLineKey = item.key || '';
            splitAgainBtn.dataset.cartLineNumber = String(lineNumber > 0 ? lineNumber : '');
            splitAgainBtn.dataset.currentPackage = String(nr > 0 ? nr : '');
            wrap.appendChild(splitAgainBtn);
          }
          if (!wrap.children.length) return;
        } else {
          if (String(z.gruppe || '').indexOf('TCG:') === 0) return;
          var normalTargets = compatiblePackageTargetsForSplit(item, z.gruppe, zeilen, reihenfolge).filter(function (target) {
            return target && String(target.group || '').indexOf('SPLIT:') === 0;
          });
          if (normalTargets.length) {
            var normalSelect = document.createElement('select');
            normalSelect.className = 'genkidama-package-action-select';
            normalTargets.forEach(function (target) {
              var opt = document.createElement('option');
              opt.value = target.group;
              opt.textContent = target.label;
              normalSelect.appendChild(opt);
            });
            wrap.appendChild(normalSelect);
            var normalMergeBtn = document.createElement('button');
            normalMergeBtn.type = 'button';
            normalMergeBtn.className = 'genkidama-split-package-btn genkidama-merge-package-btn';
            normalMergeBtn.textContent = 'Verbinden';
            normalMergeBtn.dataset.cartLineKey = item.key || '';
            normalMergeBtn.dataset.cartLineNumber = String(lineNumber > 0 ? lineNumber : '');
            wrap.appendChild(normalMergeBtn);
          }
          if (counts[z.gruppe] >= 2) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'genkidama-split-package-btn';
            btn.textContent = 'Als eigenes Paket teilen';
            btn.dataset.cartLineKey = item.key || '';
            btn.dataset.cartLineNumber = String(lineNumber > 0 ? lineNumber : '');
            btn.dataset.currentPackage = String(nr > 0 ? nr : '');
            wrap.appendChild(btn);
          }
          if (!wrap.children.length) return;
        }
        box.appendChild(wrap);
      });
    } catch (e) { /* fail-open */ }
  }

  function splitCartLineToNewPackage(lineKey, lineNumber) {
    try {
      if ((!lineKey && !lineNumber) || !lastCart || !lastCart.items) return;
      var target = null;
      var lineIdx = parseInt(String(lineNumber || '0'), 10) - 1;
      if (lineIdx >= 0 && lastCart.items[lineIdx]) target = lastCart.items[lineIdx];
      for (var i = 0; i < lastCart.items.length; i++) {
        if (target) break;
        if (lastCart.items[i].key === lineKey) {
          target = lastCart.items[i];
          break;
        }
      }
      if (!target) return;
      var props = publicCartPropertiesWithoutSplit(target);
      props._genkidama_split_package = 'SPLIT:' + Date.now() + ':' + Math.floor(Math.random() * 100000);
      props._genkidama_split_origin = splitOriginFromItem(target) || groupByVariant[target.variant_id] || groupForCartItem(target) || '';
      props._genkidama_split_created = (new Date()).toISOString();
      var payload = {
        quantity: target.quantity || 1,
        properties: props
      };
      if (lineIdx >= 0) payload.line = lineIdx + 1;
      else payload.id = lineKey;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error(t || 'Paket konnte nicht geteilt werden.'); });
        window.location.reload();
      }).catch(function (e) {
        genkiSpruch('Paket konnte nicht geteilt werden. Bitte kurz neu laden und erneut versuchen.');
        try { console.error('Genkidama Paket teilen Fehler', e); } catch (e2) {}
      });
    } catch (e) {
      genkiSpruch('Paket konnte nicht geteilt werden.');
    }
  }

  function mergeCartLineBackToPackage(lineKey, lineNumber, targetGroup) {
    try {
      if ((!lineKey && !lineNumber) || !lastCart || !lastCart.items) return;
      var target = null;
      var lineIdx = parseInt(String(lineNumber || '0'), 10) - 1;
      if (lineIdx >= 0 && lastCart.items[lineIdx]) target = lastCart.items[lineIdx];
      for (var i = 0; i < lastCart.items.length; i++) {
        if (target) break;
        if (lastCart.items[i].key === lineKey) {
          target = lastCart.items[i];
          break;
        }
      }
      targetGroup = String(targetGroup || '').trim();
      if (!target || (!splitPackageIdFromItem(target) && String(targetGroup).indexOf('SPLIT:') !== 0)) return;
      var origin = splitOriginFromItem(target) || groupByVariant[target.variant_id] || '';
      var props = publicCartPropertiesWithoutSplit(target);
      if (targetGroup && String(targetGroup).indexOf('SPLIT:') === 0) {
        props._genkidama_split_package = targetGroup;
        props._genkidama_split_origin = origin;
        props._genkidama_split_created = (new Date()).toISOString();
      }
      function changeLineInPlace() {
        var payload = {
          quantity: target.quantity || 1,
          properties: props
        };
        if (lineIdx >= 0) payload.line = lineIdx + 1;
        else if (lineKey) payload.id = lineKey;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t || 'Paket konnte nicht verbunden werden.'); });
        });
      }
      var mergePromise = lineKey ? rebuildCartLineWithProperties(target, lineKey, lineNumber, props) : changeLineInPlace();
      mergePromise.then(function () {
        window.location.reload();
      }).catch(function (e) {
        if (lineKey) {
          try { console.warn('Genkidama Paket verbinden per Neuaufbau fehlgeschlagen, versuche change.js', e); } catch (e2) {}
          changeLineInPlace().then(function () {
            window.location.reload();
          }).catch(function (changeError) {
            genkiSpruch('Paket konnte nicht verbunden werden. Bitte kurz neu laden und erneut versuchen.');
            try { console.error('Genkidama Paket verbinden Fehler', changeError); } catch (e3) {}
          });
          return;
        }
        genkiSpruch('Paket konnte nicht verbunden werden. Bitte kurz neu laden und erneut versuchen.');
        try { console.error('Genkidama Paket verbinden Fehler', e); } catch (e4) {}
      });
    } catch (e) {
      genkiSpruch('Paket konnte nicht verbunden werden.');
    }
  }

  function addExtraVersandForGroup(groupKey) {
    try {
      if (!lastCart) return;
      var inputs = cartQuantityInputs();
      var items = [];
      var sum = 0;
      var paketIndex = 0;
      var paketName = gruppenNamen[groupKey] || groupKey;
      var order = [];
      ((lastCart.items) || []).forEach(function (item, idx) {
        if (!isRealCartItemSelected(item)) return;
        var g = groupForCartItem(item);
        if (String(g || '').indexOf('EXTRA:') === 0) return;
        var input = inputForCartIndex(inputs, idx);
        var qty = input ? (parseInt(String(input.value || '0'), 10) || 0) : (item.quantity || 0);
        if (qty > 0 && order.indexOf(g) < 0) order.push(g);
        if (g !== groupKey || qty <= 0) return;
        sum += (item.final_price || item.price || 0) * qty;
        items.push((qty > 1 ? qty + 'x ' : '') + shortTitle(item.product_title || item.title));
      });
      paketIndex = order.indexOf(groupKey) + 1;
      var paketLabel = 'Paket ' + (paketIndex > 0 ? paketIndex : '?') + ' - ' + paketName;
      var fehl = Math.max(0, GRUPPEN_MINDESTWERT_CENT - sum);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: EXTRA_VERSAND_VARIANT_ID,
            quantity: 1,
            properties: {
              '_Paket-ID': groupKey,
              '_Paket': paketLabel,
              '_Service': 'Extra-Versand fuer Paket ' + (paketIndex > 0 ? paketIndex : '?'),
              '_Versandgruppe': paketName,
              '_Gruppen-Warenwert': formatEuroCent(sum),
              '_Fehlbetrag bis 150 EUR': formatEuroCent(fehl),
              '_Betroffene Artikel': items.join(' | ')
            }
          }]
        })
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error(t || 'Extra Versand konnte nicht hinzugefuegt werden.'); });
        window.location.reload();
      }).catch(function (e) {
        genkiSpruch('Extra Versand konnte nicht hinzugefuegt werden. Bitte pruefen, ob der Artikel verkaufbar ist.');
        try { console.error('Genkidama Extra Versand Fehler', e); } catch (e2) {}
      });
    } catch (e) {
      genkiSpruch('Extra Versand konnte nicht hinzugefuegt werden.');
    }
  }

  function setCheckoutBlocked(blocked, message) {
    checkoutButtons().forEach(function (btn) {
      if (blocked) {
        btn.dataset.genkidamaMaxBlocked = '1';
        btn.disabled = true;
        btn.style.opacity = '0.45';
        btn.style.cursor = 'not-allowed';
        btn.setAttribute('title', message || 'Menge liegt ueber dem Maximum pro Kunde.');
      } else if (btn.dataset.genkidamaMaxBlocked === '1') {
        // NUR freigeben, was dieses Skript selbst gesperrt hat.
        delete btn.dataset.genkidamaMaxBlocked;
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.cursor = '';
        btn.removeAttribute('title');
      }
      var wrap = btn.parentElement;
      if (!wrap) return;
      var note = wrap.querySelector('.genkidama-max-checkout-hint');
      if (blocked) {
        if (!note) {
          note = document.createElement('div');
          note.className = 'genkidama-max-checkout-hint';
          note.setAttribute('style', 'color:#d92d20;font-size:1.3rem;font-weight:700;margin:6px 0;text-align:center;');
          wrap.insertBefore(note, btn);
        }
        note.textContent = message || '';
      } else if (note) {
        note.remove();
      }
    });
  }

  function consentCheckboxForButton(button) {
    try {
      if (!button) return null;
      var formId = button.getAttribute('form');
      var form = formId ? document.getElementById(formId) : button.closest('form');
      if (!form) return null;
      var escapedId = window.CSS && window.CSS.escape ? window.CSS.escape(form.id) : form.id;
      return document.querySelector('[data-genkidama-legal-checkbox][form="' + escapedId + '"]') ||
        form.querySelector('[data-genkidama-legal-checkbox]');
    } catch (e) {
      return null;
    }
  }

  function legalConsentAlreadyOk(button) {
    var checkbox = consentCheckboxForButton(button);
    return !checkbox || !!checkbox.checked;
  }

  function selectedKd33KeysForCheckout() {
    var keys = [];
    document.querySelectorAll('[data-kd33-item-checkbox]:checked').forEach(function (input) {
      if (input.value && keys.indexOf(input.value) < 0) keys.push(input.value);
    });
    return keys;
  }

  function kd33IsActiveForCheckout() {
    return !!document.querySelector('[data-kd33-summary]') && selectedKd33KeysForCheckout().length > 0;
  }

  function redirectGuestCheckoutToCartLogin(button, event) {
    var checkbox = consentCheckboxForButton(button);
    var wrapper = checkbox && checkbox.closest ? checkbox.closest('[data-genkidama-legal-consent]') : null;
    if (!wrapper || wrapper.dataset.genkidamaCustomerAuthenticated !== 'false') return false;
    if (wrapper.dataset.genkidamaGuestCheckoutEnabled === 'true') return false;
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var loginUrl = wrapper.dataset.genkidamaCartLoginUrl || '/customer_authentication/login?return_to=%2Fcart';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Rechtliche Zustimmung': 'AGB und Widerrufsbelehrung akzeptiert' } })
    }).then(function (response) {
      if (!response.ok) throw new Error('Zustimmung konnte nicht gespeichert werden.');
      window.location.assign(loginUrl);
    }).catch(function () {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      genkiSpruch('Anmeldung konnte nicht vorbereitet werden. Bitte kurz neu laden und erneut versuchen.');
    });
    return true;
  }

  function removeCartLinesSequential(keys) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (keys || []).reduce(function (chain, key) {
      return chain.then(function () {
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t || 'Cart-Zeile konnte nicht entfernt werden.'); });
        });
      });
    }, Promise.resolve());
  }

  function notifyActivityCheckout(items) {
    // Only actual selected cart positions; this is a redirect request, not proof of checkout arrival.
    try { document.dispatchEvent(new CustomEvent('genki:checkout-requested', { detail: { items: items || [] } })); } catch (_) {}
  }

  function continueCheckoutAfterSelection(button) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var checkoutUrl = root + 'checkout';
    var activityItems = (lastCart && lastCart.items || []).filter(function (item) { return item && !isExtraVersandItem(item) && isRealCartItemSelected(item); });
    if (kd33IsActiveForCheckout()) {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Genkidama Teilzahlung Positionen': selectedKd33KeysForCheckout().join('|'),
            'Rechtliche Zustimmung': 'AGB und Widerrufsbelehrung akzeptiert',
            'KD33 Teilzahlung': '33 Prozent Anzahlung, Restbetrag spaeter'
          }
        })
      }).then(function () {
        notifyActivityCheckout(activityItems);
        window.location.assign(root + 'discount/KD33?redirect=' + encodeURIComponent(checkoutUrl));
      }).catch(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        genkiSpruch('Checkout konnte nicht vorbereitet werden. Bitte kurz neu laden und erneut versuchen.');
      });
      return;
    }
    notifyActivityCheckout(activityItems);
    window.location.assign(checkoutUrl);
  }

  function prepareSelectedCheckout(button, event) {
    try {
      if (!button || checkoutSelectionBusy || !lastCart || !lastCart.items) return false;
      if (button.dataset.genkidamaMaxBlocked === '1') return false;
      if (!legalConsentAlreadyOk(button)) return false;
      if (redirectGuestCheckoutToCartLogin(button, event)) return true;
      var inputs = cartQuantityInputs();
      if (!inputs.length || lastCart.items.length !== inputs.length) return false;
      var parkedCount = checkoutParkedLineCount(lastCart);
      if (parkedCount > CHECKOUT_PARKED_LIMIT) {
        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        genkiSpruch(checkoutParkedLimitText(parkedCount));
        evaluate();
        return true;
      }
      var selectedGroups = selectedGroupMap(inputs);
      var selectedRealQty = 0;
      var removeKeys = [];
      var heldItems = [];
      lastCart.items.forEach(function (item, idx) {
        if (!item) return;
        var qty = quantityForCartIndex(item, idx, inputs);
        if (isExtraVersandItem(item)) {
          if (!extraSelectedByGroups(item, selectedGroups) && item.key) removeKeys.push(item.key);
          return;
        }
        if (isRealCartItemSelected(item)) {
          selectedRealQty += qty;
          return;
        }
        if (qty > 0 && item.key) {
          removeKeys.push(item.key);
          heldItems.push({
            id: item.variant_id,
            quantity: qty,
            properties: cloneCartProperties(item)
          });
        }
      });
      if (selectedRealQty <= 0) {
        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        genkiSpruch('Bitte mindestens einen Artikel fuer diesen Checkout auswaehlen.');
        return true;
      }
      if (!removeKeys.length) return false;
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (heldItems.length && !writeStoredJson(CHECKOUT_HOLD_KEY, {
        createdAt: (new Date()).getTime(),
        items: heldItems
      })) {
        genkiSpruch('Auswahl konnte nicht gespeichert werden. Bitte kurz neu laden und erneut versuchen.');
        return true;
      }
      checkoutSelectionBusy = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      removeCartLinesSequential(removeKeys).then(function () {
        continueCheckoutAfterSelection(button);
      }).catch(function () {
        genkiSpruch('Checkout-Auswahl konnte nicht vorbereitet werden. Der Warenkorb wird neu geladen.');
        window.location.reload();
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function evaluate() {
    try {
      var inputs = cartQuantityInputs();
      if (!inputs.length) { restoreSelectedCheckoutTotalDisplay(); setCheckoutBlocked(false); return; }
      decorateCheckoutSelectionRows();
      updateSelectedCheckoutTotalDisplay(inputs);
      var blocked = [];
      var unknown = false;
      var selectedRealQty = 0;
      var heldRealLines = 0;
      inputs.forEach(function (input, idx) {
        var item = cartItemForInput(input, idx);
        if (item && (isExtraVersandItem(item) || !isRealCartItemSelected(item))) {
          var oldHint = lineHintFor(input, false);
          if (oldHint) oldHint.remove();
          return;
        }
        var vid = item ? String(item.variant_id) : variantIdForInput(input, idx);
        if (!vid) { return; }
        if (!Object.prototype.hasOwnProperty.call(maxByVariant, Number(vid)) &&
            !Object.prototype.hasOwnProperty.call(maxByVariant, vid)) {
          unknown = true;
          return;
        }
        var max = maxByVariant[Number(vid)] || maxByVariant[vid] || 0;
        var qty = parseInt(String(input.value || '0'), 10) || 0;
        var hint = lineHintFor(input, max > 0 && qty > max);
        if (max > 0 && qty > max) {
          blocked.push(max);
          if (hint) hint.textContent = 'Maximal ' + max + ' Stueck pro Kunde - bitte Menge verringern.';
        } else if (hint) {
          hint.remove();
        }
      });
      if (unknown) refreshLimits();
      // UNIVERSELLE GRUPPENREGEL (05.08., Boss): Liegt MEHR als eine Gruppe
      // im Warenkorb, muss JEDE Gruppe 150 EUR Warenwert erreichen - jede
      // Gruppe wird ihr eigenes Paket. Eine Gruppe allein = Betrag egal.
      // pf-Vorbesteller duerfen NIE gemischt werden, Betrag egal.
      var gruppenVerletzt = [];
      var nieMischenDrin = [];
      var zuVieleGames = false;
      if (lastCart && lastCart.items && lastCart.items.length === inputs.length) {
        var selectedGroups = selectedGroupMap(inputs);
        var extraSolvedRaw = extraVersandGroupsInCart(lastCart);
        var extraSolvedGroups = {};
        Object.keys(extraSolvedRaw).forEach(function (g) {
          if (selectedGroups[g]) extraSolvedGroups[g] = true;
        });
        var summen = {};
        var zeilen = [];
        var gruppenUnbekannt = false;
        inputs.forEach(function (input, idx) {
          var item = cartItemForInput(input, idx);
          if (!item) return;
          var vid = item.variant_id;
          var gruppe = groupForCartItem(item);
          if (gruppe === undefined) { gruppenUnbekannt = true; return; }
          var qty = parseInt(String(input.value || '0'), 10) || 0;
          if (String(gruppe).indexOf('EXTRA:') === 0) {
            var row = input.closest('.cart-item') || input.closest('tr') || input.parentElement;
            var oldBadge = row ? row.querySelector('.genkidama-paket-badge') : null;
            if (oldBadge) oldBadge.remove();
            return;
          }
          if (!isRealCartItemSelected(item)) {
            heldRealLines += Math.max(1, qty);
            var heldBadge = lineBadgeFor(input);
            if (heldBadge) heldBadge.textContent = 'Bleibt im Warenkorb - nicht in diesem Checkout';
            return;
          }
          var cent = (item.final_price || item.price || 0) * qty;
          selectedRealQty += qty;
          summen[gruppe] = (summen[gruppe] || 0) + cent;
          zeilen.push({ input: input, vid: vid, gruppe: gruppe, qty: qty });
        });
        // PAKET-ANZEIGE: Nummern in Reihenfolge des Auftretens.
        var reihenfolge = [];
        zeilen.forEach(function (zb) { if (zb.qty > 0 && reihenfolge.indexOf(zb.gruppe) < 0) reihenfolge.push(zb.gruppe); });
        zeilen.forEach(function (zb) {
          var badge = lineBadgeFor(zb.input);
          if (badge) {
            var nr = reihenfolge.indexOf(zb.gruppe) + 1;
            badge.textContent = '\uD83D\uDCE6 Paket ' + (nr > 0 ? nr : 1) + ': ' + (gruppenNamen[zb.gruppe] || 'Versandgruppe');
          }
        });
        if (!packageActionIsActive()) {
          sortCartRowsByPackage(reihenfolge);
          updateExtraVersandVisibleTitles(reihenfolge);
          decorateExtraVersandRows();
          decorateCheckoutSelectionRows();
          applyPackageFrames(reihenfolge);
          renderSplitButtons(zeilen, reihenfolge);
          cleanupOrphanExtraVersand(reihenfolge, summen);
        }
        renderHeldCheckoutRestoreNotice();
        updateCheckoutSelectionNotice(selectedRealQty, heldRealLines);
        if (!gruppenUnbekannt && reihenfolge.length) {
          schreibeVersandgruppenNotiz(reihenfolge.map(function (g, i) {
            var stueck = 0;
            zeilen.forEach(function (zb) { if (zb.gruppe === g) stueck += zb.qty; });
            return 'Paket ' + (i + 1) + ': ' + (gruppenNamen[g] || g) + ' (' + stueck + ' Artikel, ' + (summen[g] / 100).toFixed(2).replace('.', ',') + ' EUR)';
          }).join(' | '));
        }
        var aktiveGruppen = Object.keys(summen).filter(function (g) { return summen[g] > 0 && String(g).indexOf('EXTRA:') !== 0; });
        if (!gruppenUnbekannt && aktiveGruppen.length >= 2) {
          var kleinesPaketOhneExtraIstCheckoutBasis = false;
          aktiveGruppen.forEach(function (g) {
            if (gruppenNie[g]) nieMischenDrin.push(g);
            else if (summen[g] < GRUPPEN_MINDESTWERT_CENT && !extraSolvedGroups[g]) {
              if (!kleinesPaketOhneExtraIstCheckoutBasis) {
                kleinesPaketOhneExtraIstCheckoutBasis = true;
              } else {
                gruppenVerletzt.push(g);
              }
            }
          });
          // GAMES (05.08., Boss): Nur der GLEICHE Game-Artikel darf sich
          // stapeln. Zwei VERSCHIEDENE Game-Vorbesteller in einer Bestellung
          // sind verboten - egal welcher Monat, egal welcher Betrag.
          var gameGruppen = aktiveGruppen.filter(function (g) { return g.indexOf('GAME:') === 0; });
          if (gameGruppen.length >= 2) zuVieleGames = true;
        }
        if (!gruppenVerletzt.length && !nieMischenDrin.length && !zuVieleGames) {
          // Regelkonformer Zustand -> als letzten gueltigen Stand merken.
          zeilen.forEach(function (z) { if (z.qty > 0) lastValidQty[z.vid] = z.qty; });
        }
        if (gruppenVerletzt.length) {
          renderExtraVersandPanel(gruppenVerletzt.map(function (g) {
            return {
              gruppe: g,
              paketLabel: 'Paket ' + (reihenfolge.indexOf(g) + 1) + ': ' + (gruppenNamen[g] || g),
              paketKurz: 'Paket ' + (reihenfolge.indexOf(g) + 1),
              summe: summen[g] || 0
            };
          }));
        } else {
          removeExtraVersandPanel();
        }
      }
      if (blocked.length) {
        var kleinstes = Math.min.apply(null, blocked);
        setCheckoutBlocked(true, '\u26A0\uFE0F Von mindestens einem Artikel sind maximal ' + kleinstes + ' Stueck pro Kunde erlaubt - bitte Menge anpassen.');
      } else if (lastCart && lastCart.items && lastCart.items.length === inputs.length && selectedRealQty <= 0) {
        setCheckoutBlocked(true, 'Bitte mindestens einen Artikel fuer diesen Checkout auswaehlen.');
      } else if (nieMischenDrin.length) {
        setCheckoutBlocked(true, 'pf-Vorbesteller koennen nur EINZELN bestellt werden - bitte separat bestellen (die restliche Ware gerne in einer eigenen Bestellung).');
      } else if (zuVieleGames) {
        setCheckoutBlocked(true, '\u26A0\uFE0F Nur EIN Game-Vorbesteller-Artikel pro Bestellung (derselbe Artikel gerne mehrfach) - bitte die weiteren Game-Vorbesteller separat bestellen.');
      } else if (gruppenVerletzt.length) {
        setCheckoutBlocked(true, '\u26A0\uFE0F Ein Paket unter 150 EUR laeuft ueber den normalen Checkout-Versand. Jedes weitere Paket unter 150 EUR braucht Extra-Versand.');
      } else {
        setCheckoutBlocked(false);
      }
    } catch (e) {
      // FAIL-OPEN: im Zweifel nie blockieren.
      try { setCheckoutBlocked(false); } catch (e2) { /* still */ }
    }
  }

  // Live wie die Preis-Anzeige: sofort beim Tippen/Klicken auswerten ...
  document.addEventListener('input', function (ev) {
    if (ev.target && ev.target.name === 'updates[]') evaluate();
  });
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.name === 'updates[]') evaluate();
  });
  document.addEventListener('change', function (ev) {
    var box = ev.target && ev.target.matches && ev.target.matches('[data-genkidama-checkout-select]') ? ev.target : null;
    if (!box) return;
    var key = box.dataset.cartLineKey || '';
    if (!key) return;
    var selection = readCheckoutSelection();
    if (box.checked) {
      delete selection[key];
    } else {
      selection[key] = false;
      if (checkoutParkedLineCount(lastCart, selection) > CHECKOUT_PARKED_LIMIT) {
        delete selection[key];
        box.checked = true;
        genkiSpruch(checkoutParkedLimitText(CHECKOUT_PARKED_LIMIT + 1));
        evaluate();
        return;
      }
    }
    saveCheckoutSelection(selection);
    evaluate();
  });
  document.addEventListener('click', function (ev) {
    var button = ev.target && ev.target.closest ? ev.target.closest('button[name="checkout"], input[name="checkout"], #checkout') : null;
    if (!button) return;
    prepareSelectedCheckout(button, ev);
  }, true);
  document.addEventListener('submit', function (ev) {
    var submitter = ev.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    prepareSelectedCheckout(submitter, ev);
  }, true);
  document.addEventListener('submit', function (ev) {
    if (ev.defaultPrevented || !ev.submitter || ev.submitter.name !== 'checkout' || !legalConsentAlreadyOk(ev.submitter) || !lastCart) return;
    notifyActivityCheckout((lastCart.items || []).filter(function (item) { return item && !isExtraVersandItem(item) && isRealCartItemSelected(item); }));
  });
  document.addEventListener('pointerdown', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('.genkidama-package-action')) {
      packageActionHoldUntil = (new Date()).getTime() + 5000;
    }
  });
  document.addEventListener('focusin', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('.genkidama-package-action')) {
      packageActionHoldUntil = (new Date()).getTime() + 5000;
    }
  });
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.classList && ev.target.classList.contains('genkidama-package-action-select')) {
      packageActionHoldUntil = (new Date()).getTime() + 1200;
    }
  });
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('.genkidama-extra-versand-btn') : null;
    if (!btn) return;
    ev.preventDefault();
    addExtraVersandForGroup(btn.dataset.group || '');
  });
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('.genkidama-split-package-btn') : null;
    if (!btn) return;
    ev.preventDefault();
    if (btn.classList.contains('genkidama-merge-package-btn')) {
      var wrap = btn.closest('.genkidama-package-action');
      var select = wrap ? wrap.querySelector('.genkidama-package-action-select') : null;
      mergeCartLineBackToPackage(btn.dataset.cartLineKey || '', btn.dataset.cartLineNumber || '', select ? select.value : '');
      return;
    }
    splitCartLineToNewPackage(btn.dataset.cartLineKey || '', btn.dataset.cartLineNumber || '');
  });
  // ... und ein leichter Puls faengt AJAX-Neuzeichnungen des Warenkorbs ab.
  setInterval(function () {
    var inputs = cartQuantityInputs();
    if (!inputs.length) return;
    if (!lastCart || lastCart.items.length !== inputs.length) {
      refreshLimits();
    } else {
      evaluate();
    }
  }, 900);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshLimits);
  } else {
    refreshLimits();
  }
})();
